import React, { memo, useEffect, useRef, useState } from "react";
import { trackEvent } from "@leafly-com/web-utils";

import { useGetAvailableMenuItems } from "hooks/useGetAvailableMenuItems";
import { getCents, getDollars } from "utils/formatPrice";

import ButtonPlaceholder from "components/ButtonPlaceholder";
import ComparisonShoppingModal from "components/ComparisonShoppingModal";
import TrackImpression from "components/TrackImpression";

import StrainCard from ".";

const StrainCardWithMenuItems = ({
  strain,
  disableLazyLoad = false,
  orientation,
  preserveHeight,
  trackingLabel,
}: Pick<
  React.ComponentProps<typeof StrainCard>,
  | "strain"
  | "preserveHeight"
  | "orientation"
  | "trackingLabel"
  | "disableLazyLoad"
>) => {
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [lowestPrice, setLowestPrice] = useState<string | null>();
  const buttonRef = useRef(null);

  const { menuItems, menuItemWeights, initialWeight, menuItemsLoading } =
    useGetAvailableMenuItems(strain.name, "price");

  useEffect(() => {
    if (menuItems?.length && menuItems[0].normalizedQuantity === "1/8 oz") {
      const price = `$${getDollars(menuItems[0]?.price)}.${getCents(
        menuItems[0]?.price,
      )}`;
      setLowestPrice(price);
    }
  }, [menuItems]);

  return (
    <>
      <StrainCard
        strain={strain}
        disableLazyLoad={disableLazyLoad}
        orientation={orientation}
        preserveHeight={preserveHeight}
        trackingLabel={trackingLabel}
        pricePerEighth={
          lowestPrice && lowestPrice.length > 1 ? lowestPrice : undefined
        }
        accessoryTray={
          !menuItemsLoading && menuItems.length ? (
            <div className="m-lg mt-none">
              <TrackImpression
                category="Multi Option Flower Comparision"
                label="Compare Prices"
              >
                <button
                  className="button flex items-center justify-center"
                  onClick={() => {
                    setModalIsVisible(true);
                    trackEvent(
                      "Multi Option Flower Comparision",
                      "Click",
                      "Compare Prices",
                    );
                  }}
                  ref={buttonRef}
                >
                  compare prices
                </button>
              </TrackImpression>
            </div>
          ) : menuItemsLoading ? (
            <div className="m-lg mt-none">
              <ButtonPlaceholder />
            </div>
          ) : (
            <></>
          )
        }
      />
      {modalIsVisible ? (
        <ComparisonShoppingModal
          strain={strain}
          buttonRef={buttonRef}
          setModalIsVisible={setModalIsVisible}
          menuItems={menuItems}
          menuItemWeights={menuItemWeights}
          initialWeight={initialWeight}
          menuItemsLoading={menuItemsLoading}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default memo(StrainCardWithMenuItems);
